import { all, call, put, takeLatest } from 'redux-saga/effects';
import FileSaver from 'file-saver';

import { backup, maintenance } from './administrator.actions';
import { putError } from '@utils/notificationUtils';
import { dateFormat, dateNow } from '@utils/stringUtils';
import { uiActions } from '../actions';
import { LoadersNames } from '../ui/ui.actions';
import { separators } from '@config/constants';
import api from '@api';
import { Book } from '@api/types.generated';

export function* maintenanceSaga() {
  // const who = (place: string) => {
  //   if (place === 'A') {
  //     return 'ck9d3nq66000e0708mqrhfbj6';
  //   }
  //   if (place === 'D') {
  //     return 'ck6z08ttv004a0772kqrhd9d6';
  //   }
  //   return 'ck6kf0gf2005c0775usr9wlkd';
  // };
  //
  try {
    //   const result = yield call(api.book.bookListQuery);
    //   yield all(result.map((book) => {
    //     const args = {
    //       bookId: book.id,
    //       createdBy: who(book.places),
    //     };
    //     return call(api.book.setBookCreatorMutation as any, args);
    //   }));
    yield console.log('-****- No op');
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_changing_language');
  }
}

const addHeader = (): string[] => {
  let str = '';
  str += 'Title';
  str += separators.csvField;

  str += 'Authors';
  str += separators.csvField;

  str += 'Notes';
  str += separators.csvField;

  str += 'Year';
  str += separators.csvField;

  str += 'Places';
  str += separators.csvField;

  str += 'createdAt';
  str += separators.csvField;

  str += 'createdBy';

  return [str];
};

const serializeRow = (book: Book): string => {
  let str = '';
  str += book.title;
  str += separators.csvField;

  str += book.authors.map((author) => author.name).join(', ');
  str += separators.csvField;

  str += book.notes || '';
  str += separators.csvField;

  str += book.year || '';
  str += separators.csvField;

  str += book.places;
  str += separators.csvField;

  str += dateFormat(book.createdAt);
  str += separators.csvField;

  str += book.createdBy?.name || '';

  return str;
};

export function* backupSaga() {
  const filename = `Knygos_${dateNow()}.csv`;
  yield put(uiActions.showLoader(LoadersNames.fetchingData));

  try {
    const result = yield call(api.administrator.csvQuery);
    const csvContent = addHeader()
      .concat(result.map((row) => serializeRow(row)))
      .join('\n');
    const blob = new File([csvContent], filename, { type: 'data:text/csv;charset=utf-8' });
    FileSaver.saveAs(blob);
    yield put(uiActions.hideLoader(LoadersNames.fetchingData));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_changing_language');
  }
}

export function* watchAdministratorSaga() {
  yield all([yield takeLatest(maintenance, maintenanceSaga), yield takeLatest(backup, backupSaga)]);
}
